/**
 * Data dispatch channels.
 */
export enum DataDispatchChannelEnum {
	/**
	 * Represents notifications sent to the browser.
	 */
	BROWSER = 'browser',

	/**
	 * Represents notifications sent via email.
	 */
	EMAIL = 'email',

	/**
	 * Represents notifications sent to the user's in-app inbox.
	 */
	INBOX = 'inbox',

	/**
	 * Represents notifications sent as push notifications to mobile devices.
	 */
	PUSH = 'push',

	/**
	 * Represents notifications sent via SMS to mobile devices.
	 */
	SMS = 'sms',

	/**
	 * Represents notifications sent via a webhook to an external service.
	 */
	WEBHOOK = 'webhook',
}
